import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";

type Props = {
  title?: string;
  body?: string;
  className?: string;
  classId?: string;
  action?: ReactNode;
};

export function PaywallNotice({
  title = "Subscribe to unlock the full chapter",
  body = "Anonymous browsing unlocks the first chapter of every subject. Subscribe to access all chapters and study modes for your class.",
  className,
  classId,
  action,
}: Props) {
  const href = classId ? `/subscribe?class=${encodeURIComponent(classId)}` : "/subscribe";
  return (
    <div
      className={cn(
        "rounded-xl border border-accent/30 bg-accent-soft p-5",
        "flex flex-col sm:flex-row sm:items-center gap-4",
        className,
      )}
    >
      <div className="grid h-10 w-10 place-items-center rounded-lg bg-accent/20 text-accent flex-shrink-0">
        <Sparkles className="h-5 w-5" />
      </div>
      <div className="flex-1">
        <p className="font-semibold text-text">{title}</p>
        <p className="mt-0.5 text-sm text-text-muted">{body}</p>
      </div>
      {action ?? (
        <Button variant="accent" size="sm" asChild>
          <Link to={href}>Subscribe</Link>
        </Button>
      )}
    </div>
  );
}
